<template>
  <div class="container">
    <!-- survey.js 컴포넌트 삽입-->
    <survey :survey="survey"></survey>
    <div id='surveyResult'></div>    
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.29.1/moment.min.js"></script>

<script>
// surveyJS를 import한다
import * as SurveyVue from "survey-vue";
import "bootstrap/dist/css/bootstrap.css";
import numeral from "numeral";
import moment from 'moment';

// surveyJS에서 Survey 컴포넌트만 따로 빼낸다
var Survey = SurveyVue.Survey;


function monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

function roundDown(number, decimals) {
    decimals = decimals || 0;
    return ( Math.floor( number * Math.pow(10, decimals) ) / Math.pow(10, decimals) );
}

// surveyJS 스타일 설정
Survey.cssType = "bootstrap";
//Survey.cssType = "modern";
//Survey.FunctionFactory.Instance.register("diffDays", diffDays);
//Survey.textUpdateMode = "onTyping";

export default {
  components: {
    // SurveyJS 컴포넌트 사용
    Survey
  },
  data() {
    // data() {}, computed : {} 둘다 가능
    var json = {
        //title: "과소신고(초과환급)가산세",
        showNavigationButtons: false,
        //showCompletedPage: false,
        requiredText: "(필수)",
        pages: [
            {
                questions: [
                    {
                        type: "checkbox",
                        name: "기수령지원금",
                        title: "현 사업장에 고용노동부로부터 지원받는 지원금이 있습니까?",
                        choices: [
                            {
                                value:1,
                                text:"내일채움공제"
                            },
                            {
                                value:2,
                                text:"청년추가고용장려금"
                            },
                            {
                                value:3,
                                text:"청년디지털일자리"
                            },
                            {
                                value:4,
                                text:"없음"
                            },
                            {
                                value:5,
                                text:"기타"
                            }
                        ],
                        isRequired: true,
                    },
                    {
                        name: "지원금_기타",
                        type: "text",
                        title: "지원금 종류를 입력해주시기 바랍니다.",
                        visible : false,
                        isRequired: true,
                        visibleIf : "{기수령지원금} contains '5'"
                    },
                    {
                        name: "권고사직",
                        type: "radiogroup",
                        title: "최근 6개월 내 권고사직으로 퇴사한 근로자가 존재합니까?",
                        isRequired: true,
                        choices: ["예", "아니오"]
                    },
                    {
                        name: "특별고용촉진장려금_고용계획",
                        type: "radiogroup",
                        title: "올해 근로자를 고용할 계획이 있으십니까?",
                        isRequired: true,
                        choices: ["예", "아니오"]
                    },
                    {
                        name: "청년채용특별장려금_기채용",
                        type: "radiogroup",
                        title: "입사한지 6개월 미만의 만 18~34세 근로자가 고용되어 있으신가요?",
                        isRequired: true,
                        choices: ["예", "아니오"]
                    },
                    {
                        name: "청년채용특별장려금_신규채용",
                        type: "radiogroup",
                        title: "올해 내에 만 18~34세 근로자를 채용할 계획이 있으신가요?",
                        isRequired: true,
                        choices: ["예", "아니오"]
                    },
                    {
                        name: "신중년적합직무지원금",
                        type: "radiogroup",
                        title: "만50세 이상을 채용할 계획이 있으십니까?",
                        isRequired: true,
                        choices: ["예", "아니오"]
                    },
                    {
                        name: "정규직전환지원금_기채용",
                        type: "radiogroup",
                        title: "기간제·파견·사내하도급 또는 특수형태업무종사자가 있으십니까?",
                        isRequired: true,
                        choices: ["예", "아니오"]
                    },
                    {
                        name: "정규직전환지원금_신규채용",
                        type: "radiogroup",
                        title: "기간제·파견·하도급 근로자를 정규직으로 전환하여 고용할 가능성이 있으십니까?",
                        isRequired: true,
                        choices: ["예", "아니오"]
                    }
                ]
            }
        ],

        
    };

    // 모델 로드
    var surveyModel = new SurveyVue.Model(json);
    
    var 감면율 = 0;

    // 로케일 설정
    surveyModel.locale = 'ko';    

    // 모델이 렌더링 된다음 입력항목에 대한 이벤트 추가
    surveyModel.onAfterRenderQuestionInput.add(function (survey, options) {


        // 타이핑 이벤트 추가 -> 통화
        $("input.form-control").on("input", function () {

            if ($(this).attr('type') == "currency") {
                $(this).val(numeral($(this).val()).format("0,0"));
            }

        })     

    });

    surveyModel.onValueChanged.add(function (survey, options) {


        if (options.name == "수정신고일자" || options.name == "법정신고기한") {

            var 수정신고일자 = new Date(survey.getQuestionByName("수정신고일자").value);
            var 법정신고기한 = new Date(survey.getQuestionByName("법정신고기한").value)
            //var 기준일자 = 법정신고기한;
            var 경과일자 = Math.ceil(Math.abs((수정신고일자 - 법정신고기한) / (1000 * 60 * 60 * 24)));

            survey.setValue("경과일자", numeral(경과일자).value());

            // 1, 3, 6, 12, 18, 24개월 경과 여부 확인 (기준일이 주말인 경우 다음 날로)
            var due_months = [1,3,6,12,18,24,25];
            for (const x of due_months) {
                //기준일자.setMonth(법정신고기한.getMonth()+x);

                // 법정신고기한에 각 기준 개월수를 가산하여 가산세 기준일자를 계산
                var 기준일자 = new Date(survey.getQuestionByName("법정신고기한").value);
                기준일자.setMonth(기준일자.getMonth()+x);
                
                if (기준일자.getDay() == 6) {
                    기준일자.setDate(기준일자.getDate()+2)
                }
                if (기준일자.getDay() == 0) {
                    기준일자.setDate(기준일자.getDate()+1)
                }
                if (기준일자>=수정신고일자) {
                    console.log(x);
                    if (x == 1) {감면율 = 0.9}
                    if (x == 3) {감면율 = 0.75}
                    if (x == 6) {감면율 = 0.5}
                    if (x == 12) {감면율 = 0.3}
                    if (x == 18) {감면율 = 0.2}
                    if (x == 24) {감면율 = 0.1}
                    if (x == 25) {감면율 = 0}
                    break;
                }
            }
                       
        }

        //console.log(감면율);
        //console.log(numeral(survey.getQuestionByName("과소신고세액").value).value());
        //console.log(survey.getQuestionByName("과소신고유형").value);
        //console.log((100-감면율*100)/100);
        /*
        var 가산세 = roundDown(
            (numeral(survey.getQuestionByName("과소신고세액").value).value() * 
            survey.getQuestionByName("과소신고유형").value) * (1-감면율), -1);
        */
        var 과소신고세액 = numeral($("#sq_102i").val()).value();
        //var 가산세 = numeral(survey.getQuestionByName("과소신고세액").value).value() * 
        var 가산세 = 과소신고세액 * 
            survey.getQuestionByName("과소신고유형").value * (100-감면율*100)/100;

        //console.log(가산세);
        survey.setValue("감면율", numeral(감면율).format("0%"));
        survey.setValue("가산세", numeral(가산세).format("0,0"));
     
        var 납부지연가산세 = Math.floor(
            과소신고세액 * 
            survey.getQuestionByName("경과일자").value * 0.00025 / 10) *10;
        survey.setValue("납부지연가산세", numeral(납부지연가산세).format("0,0"));
        survey.setValue("가산세합계", numeral(가산세+납부지연가산세).format("0,0"));
    })


    return {
      //survey 컴포넌트를 반환
      survey: surveyModel
    };
  }
};
</script>

<style>

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/*
@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
body, div, span, h1, h2, h3, h4, h5, table, input { font-family: 'Noto Sans KR', sans-serif !important; }
*/

body {
    font-size:15px;
    
}

div.container {
    padding: 0px
}

.sv-title-actions__title {
    font-size:15px;
}

div.panel-body {
    padding : 0;
}

.sv_bootstrap_css .sv_qstn {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

div.small {
    padding-bottom: 5px;
}

@media only screen and (min-width: 1200px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: -1px !important;
    }
}

@media only screen and (max-width: 770px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: 4px !important;
    }
}

@media only screen and (max-width: 600px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: 0px !important;
    }
}

</style>
